var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-col',{attrs:{"span":24}},[(_vm.loading)?_c('div',{staticClass:"mt-2"},[_c('center',[_c('a-spin')],1)],1):_c('div',{staticClass:"pr-2"},[_c('roles-form',{attrs:{"role":_vm.role}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }